import { z } from 'zod';

const actionNames = [
    'invite_collaborators',
    'resend_invite',
    'remove_collaborator',
    'delete_design_board',
    'share_design_board',
    'update_collaborator_permission',
    'COPY_DESIGN_BOARD_PINS',
    'MOVE_DESIGN_BOARD_PINS',
] as const;

export const AllowedActions = z.enum(actionNames);
